export const debugLog = (...any: any) => {
  if (location.host.includes("myapp")) {
    console.log(...any);
  }
};
